import { appCircleIcon } from './circle';
import { appOctagonIcon } from './octagon';
import { appSquareIcon } from './square';
import { appStar01Icon } from './star-01';
import { appTriangleIcon } from './triangle';
export const shapesIcons = [appCircleIcon, appOctagonIcon, appSquareIcon, appStar01Icon, appTriangleIcon];
